// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const HomeIcon = createSvgIcon(
  <svg width={24} height={24} fill="currentColor" viewBox="0 0 24 24">
    <path d="M21.71 10.43 11.9 3.76l-9.61 6.67a.66.66 0 1 0 .75 1.09l2-1.36v8.27a1.63 1.63 0 0 0 1.63 1.63h10.69A1.63 1.63 0 0 0 19 18.43v-8.31l2 1.34q.16.1.37.11a.7.7 0 0 0 .55-.29.7.7 0 0 0-.21-.85m-10.89 8.33a.3.3 0 0 1-.31-.31v-5a.3.3 0 0 1 .31-.31h2.36a.3.3 0 0 1 .31.31v5a.3.3 0 0 1-.31.31zm6.84-.33a.3.3 0 0 1-.3.31h-2.57v-5.31a1.63 1.63 0 0 0-1.64-1.63h-2.33a1.63 1.63 0 0 0-1.64 1.63v5.31H6.64a.3.3 0 0 1-.3-.31V9.18l5.57-3.84 5.75 3.89z" />
  </svg>,
  "Home",
);
export default HomeIcon;
